"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionActions = void 0;
var PermissionActions;
(function (PermissionActions) {
    PermissionActions["Read"] = "Read";
    PermissionActions["Write"] = "Write";
    PermissionActions["Create"] = "Create";
    PermissionActions["Delete"] = "Delete";
    PermissionActions["Merge"] = "Merge";
})(PermissionActions || (exports.PermissionActions = PermissionActions = {}));
